import { render, staticRenderFns } from "./OzLoadingText.vue?vue&type=template&id=052d67d2&scoped=true&"
import script from "./OzLoadingText.vue?vue&type=script&lang=ts&"
export * from "./OzLoadingText.vue?vue&type=script&lang=ts&"
import style0 from "./OzLoadingText.vue?vue&type=style&index=0&id=052d67d2&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d67d2",
  null
  
)

export default component.exports